import urlJoin from 'url-join';
import { useAuthentication } from '~/composables/auth/useAuthentication';
import { useStore } from '~/composables/useStore';
import { CollegeLessonType, ArticleType } from '~/enums';
import { useEnotecaApp } from '../useEnotecaApp';
import { useRuntimeConfig } from '../useRuntimeConfig';

export const useCollege = () => {
  const store = useStore();
  const { isAuthenticated } = useAuthentication();
  const { FRONTEND_ORIGIN } = useRuntimeConfig();
  const { isEnotecaAppWebView } = useEnotecaApp();

  const getLessonDetail = async (lessonId: number, articleType?: string): Promise<any> => {
    const lessonDetail = await store.dispatch('college/detail/fetchLessonDetail', {
      lessonId,
      articleType,
    });
    // ストアに講座情報を格納する
    store.commit('college/detail/setLessonInfo', {
      id: lessonId,
      title: lessonDetail.area_name_ja || lessonDetail.lesson_name,
      articles: [],
      quizIds: lessonDetail.quiz_ids,
    });

    /**
     * 以下のいずれかの場合に、CMSを叩いて目次タイトルを取得する
     * ・現在のページとストアの講座IDが異なる
     * ・目次タイトルがストアにセットされていない
     */
    if (
      lessonId !== store.state.college.detail.lessonInfo.id ||
      !store.state.college.detail.lessonInfo.articles ||
      store.state.college.detail.lessonInfo.articles.length < 1
    ) {
      await store.dispatch('college/detail/fetchLessonArticleTitles', {
        articleType:
          lessonDetail.lesson_type === CollegeLessonType.AREA
            ? ArticleType.ProducingAreaLessonPage
            : ArticleType.BasicLessonPage,
        lessonId,
        articleIds: lessonDetail.article_ids,
      });
    }

    if (isAuthenticated.value) {
      // 既読の読み物一覧を取得する
      await store.dispatch('college/detail/fetchReadLessonArticles', {
        lessonType: lessonDetail.lesson_type,
        lessonId,
      });
    }

    return lessonDetail;
  };

  const getDeeplink = (deepLink: string, path: string) => {
    return isEnotecaAppWebView.value ? urlJoin(deepLink, `?url=${FRONTEND_ORIGIN}`, path) : path;
  };
  return { getLessonDetail, getDeeplink };
};
